import React, {useEffect} from 'react';
import {useAddBenefactorForm} from '../../model';
import {ActionModal, FormInput} from '../../../../shared';
import {useToaster} from '@gravity-ui/uikit';

interface AddBenefactorModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const AddBenefactorModal = ({open, setOpen}: AddBenefactorModalProps) => {
  const {values, errors, touched, handleChange, handleBlur, isLoading, errorMessage, resetForm, submitForm} =
    useAddBenefactorForm({setOpen});
  const {add} = useToaster();

  useEffect(() => {
    if (errorMessage) {
      add({
        name: 'Add benefactor error',
        theme: 'danger',
        autoHiding: 3000,
        title: errorMessage,
      });
    }
  }, [errorMessage, add]);

  return (
    <ActionModal
      open={open}
      onClose={() => setOpen(false)}
      setOpen={() => setOpen(false)}
      resetForm={resetForm}
      submitForm={submitForm}
      isLoading={isLoading}
      size={'m'}
      buttonsSize={'l'}
      caption={'Добавить пользователя'}
      textButtonApply={'Сохранить'}
      textButtonCancel={'Отменить'}>

      <FormInput
        label="Real name"
        placeholder="Real name"
        name="realName"
        value={values.realName}
        onChange={handleChange}
        onBlur={handleBlur}
        error={touched.realName && errors.realName}
      />
        <FormInput
        label="Display name"
        placeholder="Имя"
        name="displayName"
        value={values.displayName}
        onChange={handleChange}
        onBlur={handleBlur}
        error={touched.displayName && errors.displayName}
      />
    </ActionModal>
  );
}; 